export default __webpack_public_path__ + "static/media/en_us.d38b1cc7.png";